module.exports = __webpack_public_path__ + "img/exhibition3.43bbb247.png";